export default __webpack_public_path__ + "static/media/busFrontCheckedIcon.aa4ae08c.svg";